import React from 'react';

import { link } from '@aline/routes';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { onboardingSectionWidthPx } from 'src/components/get-started/GetStarted';
import { ArrowRightIcon } from 'src/components/icons/ArrowRightIcon';
import { docsRoute } from 'src/config';
import { Flag, openLink } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

import { AlineLargeIcon } from '../icons/GetStarted';

const useStyles = makeStyles()(theme => ({
  featureFlag: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2, 0),
  },
  footer: {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6, 0),
    width: '100%',
  },
  footerContent: {
    display: 'flex',
    gap: theme.spacing(8),
    justifyContent: 'space-between',
    width: onboardingSectionWidthPx,
  },
  footerInfoList: {
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  footerInfoListTitle: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(0.75),
  },
  footerList: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 2,
    gap: theme.spacing(3),
  },
  footerLogo: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: theme.spacing(3),
  },
  itemTitle: {
    '&:hover': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}));

type FooterListItem = {
  description: string;
  link: string;
  title: string;
};

const footerListItems: FooterListItem[] = [
  {
    description: "Check out Aline's product docs to learn how to use Aline effectively.",
    link: docsRoute,
    title: 'Help center',
  },
  {
    description:
      'Explore templates, workflows, playbooks and more maintained by a vibrant open-source Community.',
    link: link.CommunityIndex(),
    title: 'Aline Community',
  },
  {
    description: "Learn how Lift's entire company saved hundreds of hours on contracts.",
    link: 'https://www.aline.co/customer-stories/lift',
    title: "Lift's Customer Story",
  },
];

export function GetStartedFooter() {
  const { classes } = useStyles();

  return (
    <Box className={clsx(classes.footer, !Flag.GET_STARTED_ADVANCED && classes.featureFlag)}>
      <Box className={classes.footerContent}>
        <Box className={classes.footerList}>
          <Typography variant="subtitle1">Explore stories and resources</Typography>
          {footerListItems.map(item => {
            return (
              <Box key={item.title} className={classes.footerInfoList}>
                <Box className={classes.footerInfoListTitle}>
                  <Typography
                    className={classes.itemTitle}
                    variant="subtitle2"
                    onClick={() => openLink(item.link)}
                  >
                    {item.title}
                  </Typography>
                  <ArrowRightIcon fill="#146EE8" />
                </Box>
                <Typography variant="caption">{item.description}</Typography>
              </Box>
            );
          })}
        </Box>
        <Box className={classes.footerLogo}>
          <AlineLargeIcon />
          <Typography variant="subtitle2">
            Smart, collaborative legal agreements for all businesses.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
